import React, { memo, useCallback, useMemo, useRef, useState, } from 'react';
import Fuse from 'fuse.js';
import { Form, Input } from 'semantic-ui-react';
import { useOnClickOutside } from '../../../../../utils/hooks/useOnClickOutside';


var CategoryInput = function (_a) {
    var category = _a.category, categories = _a.categories, onUpdateTransactionCategory = _a.onUpdateTransactionCategory, transactionId = _a.transactionId;
    var _b = useState(''), inputValue = _b[0], setInputValue = _b[1];
    var _c = useState(null), categoryIdSelected = _c[0], setCategoryIdSelected = _c[1];
    var _d = useState([]), categoriesList = _d[0], setCategoriesList = _d[1];
    var _f = useState(false), isInputFocused = _f[0], setIsInputFocused = _f[1];
    var _g = useState(false), isUpdatingCategory = _g[0], setIsUpdatingCategory = _g[1];
    var handleCloseForm = useCallback(function () {
        setInputValue('');
        setIsUpdatingCategory(false);
    }, []);
    // helper library to search for categories
    var fuse = useMemo(function () {
        return new Fuse(categories, {
            isCaseSensitive: false,
            threshold: 0.3,
            keys: ['description'],
        });
    }, [categories]);
    var handleCategorySelect = useCallback(function (category_) {
        var categoryId = category_.id, description = category_.description;
        if (category === description) {
            // same category, no need to update, close form and return
            handleCloseForm();
            return;
        }
        onUpdateTransactionCategory === null || onUpdateTransactionCategory === void 0 ? void 0 : onUpdateTransactionCategory(transactionId, categoryId);
        setInputValue('');
        setCategoryIdSelected(categoryId);
        setIsUpdatingCategory(false);
    }, [category, handleCloseForm, onUpdateTransactionCategory, transactionId]);
    var handleFormSubmit = useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (categoriesList.length === 0) {
            // search result in empty -> just return
            return;
        }
        // user press "enter" -> add first category in the list
        var category = categoriesList[0].item;
        handleCategorySelect(category);
    }, [categoriesList, handleCategorySelect]);
    var handleInputChange = useCallback(function (_e, _a) {
        var value = _a.value;
        var result = fuse.search(value);
        setInputValue(value);
        setCategoriesList(result);
        if (result.length === 0) {
            // not found
            return;
        }
        setCategoryIdSelected(result[0].item.id);
    }, [fuse]);
    var handleCategoryKeyDown = useCallback(function (event, category) {
        if (event.key !== 'Enter') {
            return;
        }
        handleCategorySelect(category);
    }, [handleCategorySelect]);
    var handlePlaceholderClick = useCallback(function () {
        setIsUpdatingCategory(true);
    }, []);
    var categoryInputRef = useRef(null);
    // listen when user clicks outside of the component
    useOnClickOutside(categoryInputRef, handleCloseForm);
    var handleInputFocus = useCallback(function () {
        setIsInputFocused(true);
    }, []);
    var isRecategorizationAvailable = typeof onUpdateTransactionCategory !== 'undefined' && categories.length > 0;
    return (React.createElement("div", { className: 'CategoryInput', ref: categoryInputRef }, isUpdatingCategory && isRecategorizationAvailable ? (React.createElement(Form, { onSubmit: handleFormSubmit },
        React.createElement(Input, { placeholder: inputValue || category, size: 'mini', className: "category-input " + (inputValue ? 'filled' : ''), value: inputValue, onChange: handleInputChange, onFocus: handleInputFocus, autoFocus: isUpdatingCategory }),
        inputValue && isInputFocused && (React.createElement("div", { className: "search-results" }, categoriesList.map(function (_a) {
            var refIndex = _a.refIndex, category = _a.item;
            return (React.createElement("div", { className: 'searched-category', key: refIndex, onClick: function () { return handleCategorySelect(category); }, onKeyDown: function (event) {
                    return handleCategoryKeyDown(event, category);
                }, role: 'option', "aria-selected": categoryIdSelected === category.id, tabIndex: 0 }, category.description));
        }))))) : (React.createElement("div", { onClick: isRecategorizationAvailable ? handlePlaceholderClick : undefined, className: "input-placeholder ellipsis " + (isRecategorizationAvailable ? 'recategorizable' : '') }, category))));
};
export default memo(CategoryInput);
